var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.application ? _c('div', [_c('h1', [_vm._v("제목 : " + _vm._s(_vm.application.subject))]), _c('h2', {
    staticClass: "mt-4"
  }, [_vm._v("관리자 작성 항목")]), _c('table', {
    staticClass: "mx-auto"
  }, [_c('tbody', [_vm._l(_vm.application.items, function (item, index) {
    return [_c('tr', {
      key: index
    }, [_c('th', [_c('b', {
      staticClass: "d-inline",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
      }
    })]), _c('td', [_c('p', {
      staticClass: "d-inline ma-0",
      domProps: {
        "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
      }
    })])])];
  })], 2)]), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "href": "#content"
    }
  }, [_vm._v("상세보기")]), _c('v-dialog', {
    attrs: {
      "max-width": "640"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "mt-4"
        }, on), [_vm._v("문의처")])];
      }
    }], null, false, 1123001897)
  }, [_c('v-card', [_c('table', [_c('tbody', [_vm._l(_vm.application.helpItems, function (item, index) {
    return [_c('tr', {
      key: index
    }, [_c('th', [_c('b', {
      staticClass: "d-inline",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
      }
    })]), _c('td', [_c('p', {
      staticClass: "d-inline ma-0",
      domProps: {
        "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
      }
    })])])];
  })], 2)])])], 1), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          staticClass: "mt-4"
        }, on), [_vm._v("공고문 다운로드")])];
      }
    }], null, false, 3152174028)
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 공고문 다운로드 ")]), _c('v-card-text', [_vm._l(_vm.application.files, function (item, index) {
    return [_c('div', {
      key: index
    }, [_c('v-btn', {
      attrs: {
        "color": "blue",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.download(item.src, item.name);
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)];
  })], 2)], 1)], 1), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "href": _vm.application.link
    }
  }, [_vm._v("지원하기")]), _c('div', [_c('v-btn', {
    on: {
      "click": _vm.shareKakao
    }
  }, [_vm._v("카카오톡")]), _c('v-btn', {
    on: {
      "click": _vm.shareFacebook
    }
  }, [_vm._v("페이스북")]), _c('v-btn', {
    on: {
      "click": _vm.shareInstagram
    }
  }, [_vm._v("인스타그램")]), _c('v-btn', {
    on: {
      "click": _vm.copyClipboard
    }
  }, [_vm._v("복사")])], 1), _c('div', {
    staticClass: "pt-16",
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("상세내용(html)")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.application.content)
    }
  })])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }